<div class="account-settings-page">
  <header class="account-settings-page__title-card page-card card">
    <div class="card-body">
      <h1 class="account-settings-page__title bw-title-with-info">
        Billing &amp; subscription
        <app-info-tooltip compact placement="right" text="Paddle securely manages payment methods, renewals, invoices, and subscription changes for this account."></app-info-tooltip>
      </h1>

      @if (currentUser && billing) {
        <div class="account-settings-page__title-actions">
          <span class="badge text-bg-primary text-uppercase">{{ currentUser.plan.status }}</span>
          <span class="badge text-bg-secondary text-uppercase">{{ billing.environment }}</span>
        </div>
      }
    </div>
  </header>

  @if (isInitialLoading) {
    <div class="loading-wrapper">
      <div class="spinner-border text-primary" role="status"></div>
      <p>Loading billing details...</p>
    </div>
  } @else if (hasInitialLoadError) {
    <app-api-load-error
      title="Could not load billing details"
      message="Some error occurred while loading your subscription and billing profile."
      retryLabel="Retry"
      (retry)="loadPageData()"
    ></app-api-load-error>
  } @else if (currentUser && billing) {
    <div class="d-grid gap-4">
      <section class="page-card card">
        <div class="card-body d-grid gap-3">
          @if (billingMessage) {
            <div class="alert alert-success mb-0">{{ billingMessage }}</div>
          }
          @if (billingError) {
            <div class="alert alert-danger mb-0">{{ billingError }}</div>
          }

          <div class="billing-summary-grid">
            <article class="payment-card">
              <span class="section-kicker">Current plan</span>
              <h4>{{ currentUser.plan.name }}</h4>
              <p class="mb-0">
                @if (currentUser.plan.priceEur === 0) {
                  Free
                } @else {
                  {{ currentUser.plan.priceEur }} EUR / {{ currentUser.plan.billingInterval }}
                }
              </p>
            </article>

            <article class="payment-card">
              <span class="section-kicker">Billing profile</span>
              @if (hasPaddleRelationship) {
                <h4>Connected</h4>
                <p class="mb-0">Customer ID: {{ billing.customerId }}</p>
              } @else {
                <h4>Not connected yet</h4>
                <p class="mb-0">A Paddle billing profile is created the first time you complete a paid checkout.</p>
              }
            </article>

            <article class="payment-card">
              <span class="section-kicker">Next billing date</span>
              @if (billing.nextBilledAt) {
                <h4>{{ billing.nextBilledAt | date: 'mediumDate' }}</h4>
                <p class="mb-0">Subscription status: {{ billing.subscriptionStatus || 'unknown' }}</p>
              } @else {
                <h4>None scheduled</h4>
                <p class="mb-0">No upcoming Paddle renewal is tracked yet.</p>
              }
            </article>
          </div>

          @if (billing.scheduledChangeAction) {
            <div class="alert alert-warning mb-0">
              Scheduled billing change: <strong>{{ billing.scheduledChangeAction }}</strong>
              @if (billing.scheduledChangeEffectiveAt) {
                taking effect around {{ billing.scheduledChangeEffectiveAt | date: 'mediumDate' }}.
              }
            </div>
          }

          <div class="d-flex flex-wrap gap-2">
            <a class="btn btn-outline-secondary" routerLink="/billing/plans">Open billing & plans</a>
            <button
              class="btn btn-primary"
              type="button"
              [disabled]="isPortalBusy || !billing.portalAvailable"
              (click)="openBillingPortal()"
            >
              @if (!isPortalBusy) {
                <span>Manage in Paddle</span>
              } @else {
                <span>Opening...</span>
              }
            </button>
          </div>

          @if (!billing.portalAvailable) {
            <p class="payment-methods-page__portal-note mb-0">
              The portal becomes available after this account completes its first paid Paddle checkout.
            </p>
          }
        </div>
      </section>
    </div>
  }
</div>
